export const events = {
  payment_link_opened: "Payment Link Opened",
  payment_created: "Payment Created",
  payment_completed: "Payment Completed",
  payment_captured: "Payment Captured",
  card_saved: "Card Saved",
} as const;
